import * as React from 'react';
import { forwardRef } from 'react';

export type DMOptionProps = React.OptionHTMLAttributes<HTMLOptionElement>;

export const DMOption = forwardRef<HTMLOptionElement, DMOptionProps>(
  ({ children, ...props }, ref) => {
    return (
      <option ref={ref} {...props}>
        {children}
      </option>
    );
  },
);
DMOption.displayName = 'DMOption';
